/* eslint no-use-before-define: 0 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Translation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { intersectionWith, isArray } from 'lodash';
import { STANDARD_REFERENCE_NUMBERS } from '../constants';

const getDefaultState = () => {
  return {
    startsWithText: '',
    startsWithValues: [],
  };
};

const slugsMap = {
  equipment_id: { localizationSlug: 'EQUIPMENTS' },
  shipment_id: { localizationSlug: 'SHIPMENT', count: 2 },
  reference_numbers: { localizationSlug: 'REFERENCE_NUMBERS' },
  delivery_order: { localizationSlug: 'DELIVERY_ORDER' },
  gate_dropoff: { localizationSlug: 'GATE_DROPOFF' },
  gate_pickup: { localizationSlug: 'GATE_PICKUP' },
  house_bill_number: { localizationSlug: 'HOUSE_BILL_NUMBER' },
  isa: { localizationSlug: 'ISA' },
  master_bol: { localizationSlug: 'MASTER_BOL' },
  mg_load_id: { localizationSlug: 'MG_LOAD_ID' },
  mo_number: { localizationSlug: 'MO_NUMBER' },
  pu_number: { localizationSlug: 'PU_NUMBER' },
  seal_number: { localizationSlug: 'SEAL_NUMBER' },
  tracking_id: { localizationSlug: 'TRACKING_ID' },
  truck_order: { localizationSlug: 'TRUCK_ORDER' },
  VRID: { localizationSlug: 'VRID' },
  work_order_number: { localizationSlug: 'WORK_ORDER_NUMBER' },
  booking_number: { localizationSlug: 'BOOKING_NUMBER' },
}

class TextFilterStartsWith extends Component {
  constructor(props) {
    super(props);

    this.state = getDefaultState();
  }

  onChange = (event) => {
    const newValue = event.target.value;
    if (this.state.startsWithText !== newValue) {
      this.setState({
        startsWithText: newValue,
      });
    }
  };

  getModel() {
    const { startsWithValues } = this.state;
    const model = {};

    if (!startsWithValues.length) {
      return model;
    }

    let index = 1;
    startsWithValues.forEach((value) => {
      model[`condition${index}`] = {
        type: 'startsWith',
        filter: value,
        filterType: 'text',
      };
      index++;
    });

    return {
      ...model,
      operator: 'OR',
    };
  };

  setModel(model) {
    if (!model) {
      return this.setState(getDefaultState());
    }

    let startsWithValues = [];

    Object.keys(model).forEach((item) => {
      if (model[item].type === 'startsWith' && model[item].filter) {
        startsWithValues.push(model[item].filter);
      }
    });

    const startsWithText = startsWithValues.join('\n');

    this.setState({
      startsWithValues,
      startsWithText,
    });
  };

  handleClearFilter = () => {
    this.setState(getDefaultState(), () => {
      this.props.filterChangedCallback();
    });
  };

  handleBulkFilter = (colId) => {
    const value = this.state.startsWithText;
    let startsWithValues = [];
    if (value) {
      startsWithValues = value
        .replace(/\n/g, ',')
        .split(',')
        .map((str) => str.toUpperCase().trim())
        .filter((str) => str.length > 0);
    }

    if (startsWithValues.length > 0) {
      const startsWithText = startsWithValues.map((str) => str.toUpperCase()).join('\n');
      this.setState({ startsWithValues, startsWithText }, () => {
        this.props.filterChangedCallback();
      });
    }
  };

  doesFilterPass(params) {
    const { startsWithValues } = this.state;

    let columnId = this.props.column.colId;
    if (STANDARD_REFERENCE_NUMBERS.includes(columnId)) {
      columnId = 'reference_numbers';
    }

    const filterValues = startsWithValues.map((item) =>
      (item || '').toLowerCase(),
    );
    let columnValue = params.node.data[columnId] || '';

    if (isArray(columnValue)) {
      const values = columnValue.map((item) => item.value.toLowerCase());
      return intersectionWith(filterValues, values, (filterMatch, value) => value.includes(filterMatch)).length > 0;
    }

    columnValue = columnValue.toLowerCase();
    return (
      filterValues.filter((match) => {
        return columnValue.includes(match);
      }).length > 0
    );
  }

  isFilterActive() {
    return (this.state.startsWithValues || []).length > 0;
  }

  afterGuiAttached() {
    this.focus();
  }

  focus() {
    window.setTimeout(() => {
      const container = ReactDOM.findDOMNode(this.refs.input);
      if (container) {
        container.focus();
      }
    });
  }

  getColumnTitle(column) {
    if (column in slugsMap) {
      return slugsMap[column];
    } else {
      return { localizationSlug: 'STATUSES' };
    }
  }

  render() {
    const columnTitle = this.getColumnTitle(this.props.column.colId);
    return (
      <div className="px-4 py-5 sm:p-6">
        <label className="mb-1 form-label">
          <Translation>
            {(t) => (
              <>
                {t('ADD_COMMA_OR_NEW_LINE_STARTS_WITH', {
                  column: columnTitle.count
                    ? t(columnTitle.localizationSlug, {
                        count: columnTitle.count,
                      })
                    : t(columnTitle.localizationSlug),
                })}
              </>
            )}
          </Translation>
        </label>
        <textarea
          rows={5}
          ref="input"
          value={this.state.startsWithText}
          onChange={this.onChange}
          className="form-field"
        />
        <div className="flex justify-between mt-4">
          <button
            className="button button-secondary"
            onClick={() => this.handleClearFilter(this.props.column.colId)}
          >
            <Translation>{(t) => <>{titleize(t('CLEAR'))}</>}</Translation>
          </button>
          <button
            className="button button-green"
            onClick={() => this.handleBulkFilter(this.props.column.colId)}
          >
            <Translation>{(t) => <>{titleize(t('ADD'))}</>}</Translation>
          </button>
        </div>
      </div>
    );
  }
}

export default TextFilterStartsWith;
